import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import './add_Remove.scss'
import React,{ useState,useEffect } from 'react';
import {useImmer} from 'use-immer';
import PropTypes from 'prop-types';
import * as nodeService from '../../Shared/Services/nodeConfiguration/node.configuration.service.js'
import { right, left } from '@popperjs/core';

export default function AddRemove(props) {
    const { closeHandler, open, selectedMarkets,updateMarketType } = props;
    let markets;
    const [marketTypes,setMarketTypes]=useImmer({data:[]});

    useEffect(()=>{
        nodeService.getMarketType().then((result)=>{
            markets=result.data
            let obj=markets.map((market)=>{return {...market, isSelected:selectedMarkets.includes(market.descprition)}})
            setMarketTypes(data=>{data.data=obj})
        })
    },[selectedMarkets,open])

    function changeSelectioninnerWidth(event,i){
        setMarketTypes(data=>{data.data[i].isSelected=event.target.checked})
    }
    function onSave(){
        if(marketTypes.data.filter(marketType=>{return marketType.isSelected}).length===0){
            alert("Please select atleast one Market type")
            return;
        }
        updateMarketType((marketTypes.data.filter(marketType=>{return marketType.isSelected}).map((marketType,i)=>{return marketType.descprition})).join(","))
        closeHandler()
    }
    return (
        <>
            <Dialog data-testid="addRemoveTest" sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "50%",
                        maxWidth: "55%",  // Set your width here
                        height: "50%",
                        maxHeight: "55%"
                    },
                },
            }}
                 open={open}>
                <DialogTitle>
                    <div className="header">
                        <div className="divInline">Market Type Configuration</div>
                        <button className="closeButton" onClick={() => { closeHandler() }}><CloseIcon /></button>
                    </div>
                </DialogTitle>
                <div style={{ display: "flex" }}>
                    <h3 style={{ marginLeft: 30 + 'px' }}>Available Market Types</h3>
                    <h3 style={{ marginLeft: 202 + 'px' }}>Market Types to be Added</h3>
                </div>
                <div style={{ display: "flex", overflow: "auto" }}>
                    <div className="Box1" style={{ overflow: "auto" }}>
                        <table style={{ width:'100%'}}>
                            <tbody>
                           {marketTypes.data.map((marketType,i)=>{
                               return (<tr key={marketType.id}>
                                        <td id={marketType.id} style={{width:70 + '%'}}>{marketType.descprition}</td>
                                        <td><input data-testid="selection" type="checkbox" id={marketType.descprition} onChange={(event)=>{changeSelectioninnerWidth(event,i)}} checked={marketType.isSelected} /></td>
                                      </tr>)
                           })}
                           </tbody>
                        </table>
                    </div>
                    <div className="Box2" style={{ overflow: "auto" }}>
                        <table style={{ width:'100%'}}>
                        {marketTypes.data.filter(marketType=>{return marketType.isSelected}).map((marketType,i)=>{
                               return (<tr key={marketType.id}>
                                        <td id={marketType.descprition} style={{fontSize:15+ 'px'}}>{marketType.descprition}</td>
                                      </tr>)
                           })}
                        </table>
                    </div>
                </div>
                <div>
                    <button style={{ width: 70 + 'px', height: 30 + 'px', marginLeft: 240 + 'px', marginTop: 50 + 'px' }} onClick={()=>{onSave()}} className="save">Save</button>
                    <button style={{ width: 70 + 'px', height: 30 + 'px', marginLeft: 20 + 'px' }} onClick={() => { closeHandler() }} className="cancel">Cancel</button>
                </div>
            </Dialog>
        </>
    )

}
AddRemove.propTypes = {
    closeHandler: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedMarkets: PropTypes.arrayOf(PropTypes.string).isRequired,
    updateMarketType: PropTypes.func.isRequired
};

AddRemove.defaultProps = {
    closeHandler: null, 
    open: false, 
    selectedMarkets: [],
    updateMarketType: null
};